import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("wt_cart") || "[]"));
  const [open, setOpen] = useState(false);
  const [gift, setGift] = useState(() => JSON.parse(localStorage.getItem("wt_gift") || "null") || { enabled: false, sender_name: "", recipient_name: "", recipient_email: "", message: "", notify_recipient: false });
  useEffect(() => { localStorage.setItem("wt_gift", JSON.stringify(gift)); }, [gift]);

  useEffect(() => { localStorage.setItem("wt_cart", JSON.stringify(items)); }, [items]);

  const add = (p, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === p.id);
      if (ex) return prev.map((i) => (i.product_id === p.id ? { ...i, quantity: i.quantity + qty } : i));
      return [...prev, { product_id: p.id, name: p.name, price: p.price, image: p.images[0], quantity: qty }];
    });
    toast.success(`${p.name} added to cart`);
    setOpen(true);
  };
  const update = (id, quantity) =>
    setItems((prev) => prev.map((i) => (i.product_id === id ? { ...i, quantity: Math.max(1, quantity) } : i)));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const clear = () => { setItems([]); setGift({ enabled: false, sender_name: "", recipient_name: "", recipient_email: "", message: "", notify_recipient: false }); };
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.quantity * i.price, 0);

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, count, subtotal, open, setOpen, gift, setGift }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
